import {Grid, Typography} from '@yandex-delivery/blocks'
import React from 'react'

import {classes} from './TitleSlot.classes'
import type {TitleSlotProps} from './TitleSlot.types'

export function TitleSlot({
  title,
  titleTypography,
  subtitle,
  subtitleTypography,
  subtitlePosition = 'down',
  startIcon,
  endIcon,
  onClick: handleClick,
  ...gridProps
}: TitleSlotProps): React.ReactElement {
  const direction = subtitlePosition === 'up' ? 'column-reverse' : 'column'

  return (
    <Grid alignItems="center" wrap="nowrap" container {...gridProps} onClick={handleClick}>
      {startIcon && (
        <Grid className={classes.icon} item>
          {startIcon}
        </Grid>
      )}
      <Grid item xs>
        <Grid direction={direction} container>
          {title && (
            <Grid item xs>
              <Typography group="tight" thickness="regular" variant="body2" {...titleTypography}>
                {title}
              </Typography>
            </Grid>
          )}
          {subtitle && (
            <Grid item xs>
              <Typography group="tight" thickness="regular" variant="caption1" {...subtitleTypography}>
                {subtitle}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      {endIcon && (
        <Grid className={classes.icon} item>
          {endIcon}
        </Grid>
      )}
    </Grid>
  )
}
